import { render, staticRenderFns } from "./Verband.vue?vue&type=template&id=e20b36b6&scoped=true"
import script from "./Verband.vue?vue&type=script&lang=js"
export * from "./Verband.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20b36b6",
  null
  
)

export default component.exports